import { useState } from "react";
import { Share2, Check } from "lucide-react";
import { toast } from "sonner";

// Native share sheet where available (mobile); otherwise copies the link. No navigation, no layout change.
export const ShareButton = ({ title, text, path, className = "", testId = "share-button", tone = "dark" }) => {
  const [copied, setCopied] = useState(false);
  const share = async () => {
    const url = `${window.location.origin}${path || window.location.pathname}`;
    const payload = { title: title || document.title, text: text || title || document.title, url };
    try {
      if (navigator.share && navigator.canShare?.(payload) !== false) {
        await navigator.share(payload);
        return;
      }
    } catch (e) {
      if (e?.name === "AbortError") return;
    }
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Link copied");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      window.prompt("Copy this link", url);
    }
  };
  const cls = tone === "light"
    ? "bg-white/15 text-white border border-white/30 hover:bg-white/25"
    : "bg-white text-black border border-black/10 hover:bg-neutral-100";
  return (
    <button type="button" onClick={share} data-testid={testId} aria-label="Share"
      className={`inline-flex items-center gap-1.5 rounded-full px-3.5 min-h-[44px] text-xs font-bold transition-colors ${cls} ${className}`}>
      {copied ? <Check size={14} /> : <Share2 size={14} />} {copied ? "Copied" : "Share"}
    </button>
  );
};
